import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  cardBody: {
    background: theme.colorPalette.beige_25,
    width: '100%',
    margin: 0,
    padding: theme.spacing(6, 8)
  },
  readOnlyField: {
    '& > div': {
      backgroundColor: 'transparent'
    },
    '& input, & input:focus': {
      fieldSizing: 'content',
      width: 'auto',
      paddingLeft: 0,
      backgroundColor: 'transparent',
      cursor: 'default'
    }
  },
  containerDark: {
    backgroundColor: theme.colors.card_background_secondary,
    width: '100%',
    padding: theme.spacing(6, 8),
    margin: 0,
    borderBottomRightRadius: theme.sizes.roundCorners,
    borderBottomLeftRadius: theme.sizes.roundCorners,
    rowGap: theme.spacing(4)
  },
  header: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  headerStatus: {
    paddingTop: 4,
    fontStyle: 'italic',
    textTransform: 'none',
    maxWidth: 570
  },
  // #35176: quiet identification of Rebuilt / Lemon-buyback vehicles so Claims can apply the right
  // depreciation. Deliberately understated (a bold line in the card header), not a warning banner.
  brandedTitleTag: {
    paddingTop: 4,
    fontWeight: 'bold',
    textTransform: 'none',
    maxWidth: 570
  },
  addCarDetailsForm: {
    display: 'flex',
    flexDirection: 'column'
  },
  // #35042: read-only display of the CFM/farm-auto rating symbols (liability + physical damage) the
  // rater keys on. Stacked label-over-value, matching the width of the make/model symbol inputs.
  readOnlySymbol: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(2)
  },
  iconButtonRoot: {
    color: theme.colors.button__background_secondary,
    padding: 0
  },
  iconButtonLabel: {
    height: 32,
    width: 32
  },
  icon: {
    height: 32,
    marginBottom: theme.spacing(2)
  },
  collapse: {
    transform: 'rotate(180deg)'
  },
  addCarDetailsLabel: {
    fontSize: 16,
    cursor: 'pointer'
  },
  addCarDetailsButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
    color: theme.colorPalette.orange_50
  },
  luxuryCheckbox: {
    marginTop: 10,
    paddingLeft: theme.spacing(1)
  },
  noMargin: {
    margin: 0
  },
  link: {
    display: 'block',
    color: theme.colorPalette.orange_50,
    marginTop: theme.spacing(4),
    fontWeight: 700
  }
});

export default makeStyles(styles);
